// @ts-check
/** @jsxRuntime classic */
/** @jsx jsx */
import { gql } from '@apollo/client';
import { P } from '@bottlebooks/gatsby-design-system';
import { Trans } from '@lingui/macro';
import { graphql } from 'gatsby';
import { jsx } from 'theme-ui';
import Section from '../Section/Section';

export default function ProductDescription({ product, ...rest }) {
  if (!product?.description) return null;
  return (
    <Section title={<Trans>Description</Trans>} {...rest}>
      {product.description.split('\n\n').map((p, index) => (
        <P key={index} variant="large">
          {p}
        </P>
      ))}
    </Section>
  );
}

export const fragment = graphql`
  fragment ProductDescription on Product {
    description: wineDescription
  }
`;

ProductDescription.fragment = gql`
  fragment ProductDescription on Product {
    description
  }
`;
